export const pad = (n: number) => (n < 10 ? '0' + n : n)
